import CLink from "./CLink";
import { Modal as CModal } from "./CModal";
import { CDropdown } from "./CDropdown";

import CCheckbox from "./CCheckbox";
import { CircleProgress, CircleProgress2 } from "./CircleProgress";
import { CircleProgress3 } from "./CP";
import CSelect from "./CSelect";
import CToggle from "./CToggle";
// import OffCanvas from "./OffCanvas";

export {
	CLink,
	CModal,
	CDropdown,
	CCheckbox,
	CircleProgress,
	CircleProgress2,
	CircleProgress3,
	CSelect,
	CToggle,
};
